import {
  MessageTemplate,
  MessageTouchPoint,
} from "@kahunmedical/common-configuration/dist/configuration/messageTemplate";
import { SupportedLanguages } from "@kahunmedical/common-configuration/dist/configuration/supportedLanguages";

export const DEFAULT_TEMPLATE_PARAMS: Record<string, string> = {
  patient_first_name: "#patient_first_name#",
  patient_last_name: "#patient_last_name#",
  patient_full_name: "#patient_full_name#",
  visit_date: "#visit_date#",
  case_url: "#case_url#",
  case_url_text: "#case_url_text",
  clinic_name: "#clinic_name#",
  patient_code_id: "#patient_code_id#",
};

export const DEFAULT_SMS_INLINE_TEMPLATE =
  "Hello {{patient_first_name}}, \n" +
  "Before your scheduled visit with your primary care physician on {{visit_date}} please fill in this intake form: {{{case_url}}}. \n" +
  "Your responses will be shared with your doctor before the visit to help them better understand your health needs and make your visit more efficient. \n" +
  "Thank you for your cooperation!\n" +
  "{{clinic_name}}";

export const DEFAULT_EMAIL_TEMPLATE: MessageTemplate = {
  touchPoint: MessageTouchPoint.SendConversationLink,
  templateId: "template_kahun_default",
  inlineTemplate: "",
  templateParams: DEFAULT_TEMPLATE_PARAMS,
  language: SupportedLanguages.English_US,
  enabledForNonClinicUsers: false,
};

export const DEFAULT_INLINE_EMAIL_JS_TEMPLATE_ID = "template_kahun_inline";
export const DEFAULT_EMAILJS_USER_ID = "YVWswfL3DQMsS1P8E";
export const DEFAULT_EMAILJS_ACCESS_TOKEN = process.env.EMAILJS_ACCESS_KEY; //defined using GitHub env settings (look in communication.deploy.yml)
export const DEFAULT_EMAILJS_SERVICE_ID = "kahun_noreply";

export const DEFAULT_EMAIL_INLINE_TEMPLATE =
  "Hello {{patient_first_name}},\n\n" +
  "Before your visit on {{visit_date}}, we invite you to use our new Medical AI diagnosis tool powered by Kahun.\n\n" +
  "Your answers will help our clinicians better understand your medical needs and provide you with personalized care.\n\n" +
  '<a href="{{case_url}}" target="_blank"><strong>Click here to start</strong></a>\n\n' +
  "Thank you for your cooperation\n\n" +
  "<strong>{{clinic_name}}</strong>";
